import styled from 'styled-components';
import { darken, rgba } from 'polished';

export const Container = styled.aside`
  width: 280px;

  .sidebar-group-title {
    color: ${(props) => props.theme.$gray900};
  }

  .sidebar-link {
    color: ${(props) => props.theme.$gray700};
  }

  .sidebar-link .material-icons {
    font-size: 16px;
  }

  .sidebar-link:hover {
    background: ${(props) => props.theme.$gray200};
  }

  .sidebar-count {
    font-size: 12px;
    font-weight: 600;
  }

  .sidebar-link.active {
    color: ${(props) => darken(0.1, props.theme.$success)};
    background: ${(props) => rgba(props.theme.$success, 0.12)};
    font-weight: 600;
  }
`;
